var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMakerdao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    alt: "Logo for Maker dao",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Maker dao") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    rx: 32,
    fill: "#4FA89B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3300_8589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 101C78.8904 101 101.5 78.6142 101.5 51C101.5 23.3858 78.8904 1 51 1C23.1096 1 0.5 23.3858 0.5 51C0.5 78.6142 23.1096 101 51 101Z",
    fill: "#4FA89B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1439 66V42.4667L44.169 55.8983V66H48.7696V54.95C48.7687 54.5394 48.6718 54.1346 48.4863 53.7673C48.3008 53.4001 48.0319 53.0804 47.7007 52.8333L25.8409 36.5383C25.4411 36.2443 24.9667 36.0658 24.4706 36.0227C23.9744 35.9795 23.4759 36.0735 23.0305 36.294C22.585 36.5145 22.21 36.853 21.9472 37.2719C21.6844 37.6907 21.544 38.1736 21.5417 38.6667V66H26.1439ZM75.9941 66V42.4667L57.969 55.8983V66H53.3684V54.95C53.3693 54.5394 53.4662 54.1346 53.6517 53.7673C53.8372 53.4001 54.1061 53.0804 54.4374 52.8333L76.2971 36.545C76.6965 36.2513 77.1702 36.0729 77.6658 36.0295C78.1613 35.9861 78.6593 36.0794 79.1046 36.2991C79.5498 36.5189 79.9249 36.8564 80.1882 37.2743C80.4515 37.6922 80.5928 38.1741 80.5964 38.6667V66H75.9941Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3300_8589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 100,
    fill: "white",
    transform: "translate(0.5 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakerdao);
export default __webpack_public_path__ + "static/media/makerdao.6391a081e26f924b9f81785b9324ab25.svg";
export { ForwardRef as ReactComponent };